/** Top-level keys that contain nested conditional field groups */
export type ProficiencyFeedbackGroupKey =
  | "validationTeam"
  | "missTdsGroup"
  | "misinterpretPolicyGroup"
  | "performTestsGroup";

export interface PfConditionalQuestion {
  label: string;
  group: ProficiencyFeedbackGroupKey;
  parentField: string;
  extraField: string;
  extraFieldLabel: string;
  extraFieldType: "text" | "multiselect";
  showOn: boolean;
}

const PF_FORM_YES_NO_QUESTIONS: readonly PfConditionalQuestion[] = [
  {
    label:
      "Did the validation team have 2 weeks to review the package before termination:",
    group: "validationTeam",
    parentField: "validationTeamTwoWeeks",
    extraField: "validationTeamDays",
    extraFieldLabel: "Include how many days were available?",
    extraFieldType: "text",
    showOn: false,
  },
  {
    label: "Did the VID miss any TDs?",
    group: "missTdsGroup",
    parentField: "missTds",
    extraField: "missTdsEcrs",
    extraFieldLabel: "ECR numbers supporting this:",
    extraFieldType: "multiselect",
    showOn: true,
  },
  {
    label: "Did the VID misinterpret any policies?",
    group: "misinterpretPolicyGroup",
    parentField: "misinterpretPolicy",
    extraField: "misinterpretedPolicies",
    extraFieldLabel: "Indicate which policy(ies):",
    extraFieldType: "multiselect",
    showOn: true,
  },
  {
    label: "Did the VID fail to perform required test(s):",
    group: "performTestsGroup",
    parentField: "performTests",
    extraField: "performTestsEcrs",
    extraFieldLabel: "Indicate the ECR numbers supporting this:",
    extraFieldType: "multiselect",
    showOn: true,
  },
] as const;

export { PF_FORM_YES_NO_QUESTIONS };
